"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcMetadataParserFactory = void 0;
class VcMetadataParser {
    // parse vcType-agnostic metadata
    parseCommon(credential) {
        const metadata = { vcType: credential.type };
        return metadata;
    }
    // parse vcType-specific metadata
    /* eslint-disable-next-line no-unused-vars */
    parseSpecific(credential) {
        return { data: {} };
    }
    parse(credential) {
        const baseMetadata = this.parseCommon(credential);
        const addOnMetadata = this.parseSpecific(credential);
        return Object.assign(Object.assign({}, baseMetadata), addOnMetadata);
    }
}
class HealthPassportParser extends VcMetadataParser {
    parseSpecific(credential) {
        try {
            const targetResources = ['Specimen', 'Observation', 'Organization'];
            const entriesIn = credential.credentialSubject.data.fhirBundle.entry;
            const entriesOut = entriesIn.filter(function (entry) {
                return targetResources.includes(entry.resource.resourceType);
            });
            return { data: entriesOut };
        }
        catch (error) {
            console.log('Error:', error);
        }
    }
}
class VcMetadataParserFactory {
    createParser(vcType) {
        switch (vcType) {
            case 'HealthPassportBundleCredentialV1': // TODO: can we import this value from vc-data in a modular way?
                return new HealthPassportParser();
            default:
                return new VcMetadataParser();
        }
    }
}
exports.VcMetadataParserFactory = VcMetadataParserFactory;
//# sourceMappingURL=VcMetadataParser.js.map